module.exports = __webpack_public_path__ + "media/images/front/pc/for-doctors-refine/img_step01-6c8119445b22629f951cd5525cc2fde4.png";